module.exports = __webpack_public_path__ + "img/postit_426x426.aa46f4be.png";